var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Email_icon",
    "data-name": "Email  icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.065,
    height: 23.76,
    viewBox: "0 0 35.065 23.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Email_icon-2",
    "data-name": "Email  icon",
    d: "M271.638,155.492v20.836l10.818-10.422C279.093,162.694,274.313,158.075,271.638,155.492Zm15.943,12.478a2.343,2.343,0,0,0,3.385-.255c1.327-1.319,10.3-9.841,14.3-13.631H273.08C279.625,160.414,286.821,167.336,287.581,167.971Zm8.159-2.051L306.7,176.481V155.5C303.957,158.1,299.06,162.747,295.741,165.92Zm-3.3,3.171a4.632,4.632,0,0,1-3.284,1.459,4.577,4.577,0,0,1-2.914-1.083c-.237-.2-1.02-.927-2.327-2.168l-10.946,10.545h32.25l-10.936-10.532C293.306,168.245,292.7,168.829,292.439,169.09Z",
    transform: "translate(-271.638 -154.084)",
    fill: "#3c3c3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailicon);
export default __webpack_public_path__ + "static/media/Email  icon.e52d6e4524e52cd3e3b18f4e1d4e0bd7.svg";
export { ForwardRef as ReactComponent };